module.exports = __webpack_public_path__ + "img/transfer17.f1769831.jpeg";